import { alterDate, stringToDate } from '@hc-frontend/utils'
import { enableMultiCarrierPlans } from 'utils/experiments'
import formatMonth from 'utils/date/format-month'
import store from 'utils/store/withMiddleware'
import getPolicy from './getPolicy'

const getLabelMultiCarrier = state => {
  const plan = state.plans[state.planId]
  const { policy } = getPolicy({ plan })

  return formatMonth(policy.monthly.endDate)
}

const getLabelStandalone = state => {
  if (state.endDate) {
    return formatMonth(state.endDate)
  }

  const period = state.filters.period != null ? +state.filters.period : +state.period
  const policies = state.filters.policies != null ? +state.filters.policies : 1
  const completeDuration = period * policies

  const endDate = alterDate({
    date: stringToDate(state.sDate),
    days: completeDuration - 1
  })

  return formatMonth(endDate)
}

function getEndDateLabel() {
  const state = store.getState()

  if (enableMultiCarrierPlans()) {
    return getLabelMultiCarrier(state)
  } else {
    return getLabelStandalone(state)
  }
}

export default getEndDateLabel
